function colorMapToClass(hexColor: string): string {
	const colorMap = {
		'#3399CC': 'blue-50',
		'#666699': 'deep-purple-50',
		'#99CC33': 'teal-50',
		'#339966': 'green-50',
		'#FFCC33': 'orange-50',
		'#FF3333': 'red-50',
	};
	const clazz = (hexColor && colorMap[hexColor]) || '';
	return clazz;
}

function colorMapToRGB(hexColor: string): string {
	const colorMap = {
		'#3399CC': '#2196f3', // blue-500
		'#666699': '#673ab7', // deep-purple-500
		'#99CC33': '#4caf50', // teal-500
		'#339966': '#009688', // green-500
		'#FFCC33': '#ff9800', // orange-500
		'#FF3333': '#f44336', // red-500
	};
	const clazz = (hexColor && colorMap[hexColor]) || '';
	return clazz;
}

export const vhColorClasses = {
	colorMapToClass,
	colorMapToRGB,
};
